import moment from "moment"
import React, { useContext, useState } from "react"
import { Col, Container, Row, Table } from "react-bootstrap"
import toast from "react-hot-toast"
import { useNavigate, useParams } from "react-router-dom"
import Navbar from "../../../Components/Navbar/Navbar"
import TableTemp from "../../../Components/TableTemplate/Table"
import {
  dateFormat,
  formatDecimal,
  isAdmin,
  numberFormat,
  refreshPage,
  toastStyle,
  TokenExpiry,
} from "../../../Helpers/Utils/Common"
import { getSalesOrder } from "../../../Helpers/apiCalls/SalesModule/SalesOrderApi"
import Footer from "../../../Components/Footer/Footer"
import ElmhurstLogo from "../../../Assets/Images/elmhurst-initial-logo.png"
import noDataImg from "../../../Assets/Images/no-data-img.png"
import Modal from "antd/es/modal/Modal"
import AttachmentModal from "../../../Components/AttachmentModal/AttachmentModal"
import { Context } from "../../../Helpers/Utils/Context"

export default function SalesOrderPrint() {
  const { id } = useParams() // id
  let navigate = useNavigate()

  const [inactive, setInactive] = useState(true)
  const [salesInvoice, setSalesInvoice] = useState([])
  const [items, setItems] = useState([])
  const [paymentInfo, setPaymentInfo] = useState([])
  const [fileList, setFileList] = useState([])
  const [previewFile, setPreviewFile] = useState("")
  const [preview, setPreview] = useState(false)
  const [startAt, setStartAt] = useState(0)
  /* Attachments Modal */
  const [showAttachmentsModal, setShowAttachmentsModal] = useState(false)
  const handleShowAttachmentsModal = () => setShowAttachmentsModal(true)
  const handleCloseAttachmentsModal = () => setShowAttachmentsModal(false)

  const { currentTab } = useContext(Context)

  async function fetchSalesInvoice() {
    setSalesInvoice({})
    setPaymentInfo([])
    setItems([])

    const response = await getSalesOrder({ id: id, status: currentTab })

    if (response.error) {
      TokenExpiry(response)
    } else {
      console.log(response)
      setFileList(response.data.data[0].sales_order_attachments)
      var data = response.data.data[0]

      var ordered_items = data.sales_order_items.map((item) => {
        var info = item
        info.item_id_value = { label: item.item_name, value: item.item_id }
        info.priceValue = { label: item.price, value: item.price }
        return info
      })

      setSalesInvoice(data)
      setItems(ordered_items)
    }
  }

  console.log(salesInvoice)

  async function handlePrint() {
    toast.loading("Printing sales order...", { style: toastStyle() })
    setTimeout(() => {
      toast.dismiss()
      Print()
    }, 1000)
  }
  async function handlePrintWarehouse() {
    toast.loading("Printing sales order for warehouse...", {
      style: toastStyle(),
    })
    setTimeout(() => {
      toast.dismiss()
      PrintWarehouse()
    }, 1000)
  }

  function renderTable() {
    return (
      <Table className="align-middle">
        <thead>
          <tr>
            <th></th>
            <th>Item Code</th>
            <th>Product</th>
            <th>Quantity</th>
            <th>U o M</th>
            <th>Size</th>
            <th>Price/Unit</th>
            <th>Discount</th>
            <th>Amount</th>
            {(salesInvoice.status === "incomplete" ||
              salesInvoice.status === "completed") && (
              <>
                <th>Sent Qty</th>
                <th>Balance</th>
                <th>Latest Inv Date</th>
              </>
            )}
            <th>Remarks</th>
          </tr>
        </thead>
        <tbody>
          {items.map((item, index) => {
            return (
              <tr className="req-table-w-border-bottom">
                <td className="req-table-w-border-sides">{index + 1}</td>
                <td className="req-table-w-border-sides">{item.item_code}</td>
                <td className="req-table-w-border-sides">
                  {item.description
                    ? item.item_name
                      ? item.description + " - " + item.item_name
                      : item.description
                    : item.item_name}
                </td>
                <td className="req-table-w-border-sides">
                  {numberFormat(item.qty)}
                </td>
                <td className="req-table-w-border-sides">{item.unit}</td>
                <td className="req-table-w-border-sides">{item.item_size}</td>
                <td className="req-table-w-border-sides">
                  {numberFormat(item.price)}
                </td>
                <td>{`${formatDecimal(item.discount_amount)} (${formatDecimal(
                  item.discount_percentage
                )}%)`}</td>
                <td className="req-table-w-border-sides">
                  {numberFormat(item.amount)}
                </td>
                {(salesInvoice.status === "incomplete" ||
                  salesInvoice.status === "completed") && (
                  <>
                    <td className="req-table-w-border-sides">
                      {numberFormat(item.qty_received)}
                    </td>
                    <td className="req-table-w-border-sides">
                      {numberFormat(item.remaining_qty)}
                    </td>
                    <td className="req-table-w-border-sides">
                      {dateFormat(item.latest_invoice_date)}
                    </td>
                  </>
                )}
                <td className="req-table-w-border-sides">
                  {item.item_remarks}
                </td>
              </tr>
            )
          })}
          {/* <tr>
                        <td colSpan={7}>
                            <div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={5}></td>
                        <td className="left">Subtotal</td>
                        <td className="right">
                            {salesInvoice.subtotal
                                ? numberFormat(salesInvoice.subtotal)
                                : "0.00"}
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={5}></td>
                        <td className="left">Service Fee</td>
                        <td className="right">
                            {salesInvoice.service_fee
                                ? numberFormat(salesInvoice.service_fee)
                                : "0.00"}
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={5}></td>
                        <td className="left">Delivery Fee</td>
                        <td className="right">
                            {salesInvoice.delivery_fee
                                ? numberFormat(salesInvoice.delivery_fee)
                                : "0.00"}
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={5}></td>
                        <td className="left">GRAND TOTAL</td>
                        <td className="right">
                            {salesInvoice.grand_total
                                ? numberFormat(salesInvoice.grand_total)
                                : "0.00"}
                        </td>
                    </tr> */}
        </tbody>
      </Table>
    )
  }

  function renderWarehouseTable() {
    return (
      <Table className="align-middle">
        <thead>
          <tr>
            <th>Transfer Qty</th>
            <th>Item</th>
            <th>Unit</th>
            <th className="text-end">Quantity</th>
            <th>Remarks</th>
          </tr>
        </thead>
        <tbody>
          {items.map((item) => {
            return (
              <tr className="req-table-w-border-bottom">
                <td className="req-table-w-border-sides"></td>
                <td className="req-table-w-border-sides">{item.item_name}</td>
                <td className="text-lowercase req-table-w-border-sides">
                  {item.unit}
                </td>
                <td className="text-end req-table-w-border-sides">
                  {numberFormat(item.qty)}
                </td>
                <td className="req-table-w-border-sides"></td>
              </tr>
            )
          })}
        </tbody>
      </Table>
    )
  }

  function Print() {
    let printContents = document.getElementById("printablediv").innerHTML
    let originalContents = document.body.innerHTML
    document.body.innerHTML = printContents
    window.print(printContents)
    document.body.innerHTML = originalContents
    refreshPage()
  }
  function PrintWarehouse() {
    let printContents = document.getElementById(
      "printabledivwarehouse"
    ).innerHTML
    let originalContents = document.body.innerHTML
    document.body.innerHTML = printContents
    window.print(printContents)
    document.body.innerHTML = originalContents
    refreshPage()
  }

  function handleClickImageThumbnail(index) {
    handleShowAttachmentsModal()
    setStartAt(index)
  }

  //
  React.useEffect(() => {
    fetchSalesInvoice()
  }, [])

  return (
    <div>
      <div className="page">
        <Navbar
          onCollapse={(inactive) => {
            setInactive(inactive)
          }}
          active={"SALES"}
        />
      </div>
      <br />
      <br />
      <div className={`manager-container ${inactive ? "inactive" : "active"}`}>
        <div className="print-container px-3 py-2" id="printablediv">
          <div className="print-header-invoice-elm">
            <div className="d-flex justify-content-center py-1">
              <img src={ElmhurstLogo} className="print-logo-elm" alt="" />
            </div>
            <div className="print-top">
              <h5 className="print-shop-header-elm d-flex justify-content-center text-center">
                497 D Molave Extension, Lahug, Cebu City
              </h5>
              {/* <h5 className="print-shop-header-elm d-flex justify-content-center">San Roque, Cebu City</h5> */}
            </div>
          </div>
          <div className="print-header2-invoice-container d-flex flex-column flex-sm-row mb-3">
            <div className="invoice-header2-left w-full">
              <h2 className="delivery-title-elm">SALES ORDER</h2>
              <h4 className="receiver-name-elm print-data fs-5">
                To: {salesInvoice.customer_name}
              </h4>
              <h5 className="print-pi-tin-elm print-data">
                TIN: {salesInvoice.customer_tin}{" "}
              </h5>
              <h5 className="print-pi-address-elm print-data">
                Address: {salesInvoice.address}
              </h5>
              <h5 className="print-pi-address-elm print-data">
                Contact No.: {salesInvoice.contact_no}
              </h5>
              <h5 className="print-pi-address-elm print-data">
                Terms: {salesInvoice.terms} days
              </h5>
            </div>
            <div className="invoice-header2-right w-full">
              <div className="invoice-header2-right-left">
                <h5 className="text-end print-table-footer-label">Date: </h5>
                {salesInvoice.invoice_no && (
                  <h5 className="text-end print-table-footer-label">
                    Invoice No.:{" "}
                  </h5>
                )}
                <h5 className="text-end print-table-footer-label">
                  SO Ref. No.:{" "}
                </h5>
                {salesInvoice.customer_po_no !== "undefined" &&
                salesInvoice.customer_po_no !== undefined ? (
                  <h5 className="text-start print-table-footer-label">
                    CUST PO NO.
                  </h5>
                ) : null}
                <h5 className="text-end print-table-footer-label">
                  Due Date:{" "}
                </h5>
                <h5 className="text-end print-table-footer-label">
                  Ship Via:{" "}
                </h5>
                <h5 className="text-end print-table-footer-label">
                  Delivery Date:{" "}
                </h5>
                {/* <h5 className="print-shop-header-elm invoice-1 d-flex justify-content-end">Delivery Note No.: </h5> */}
              </div>
              <div className="invoice-header2-right-right pt-1">
                <h5 className="text-start print-table-footer-label">
                  {moment(salesInvoice.sales_date).format("MMMM DD, yyyy")}
                </h5>
                <h5 className="text-start print-table-footer-label">
                  {salesInvoice.invoice_no}
                </h5>
                <h5 className="text-start print-table-footer-label">
                  {salesInvoice.id}
                </h5>
                {salesInvoice.customer_po_no !== "undefined" &&
                salesInvoice.customer_po_no !== undefined ? (
                  <h5 className="text-start print-table-footer-label">
                    {salesInvoice.customer_po_no}
                  </h5>
                ) : null}
                <h5 className="text-start print-table-footer-label">
                  {dateFormat(salesInvoice.due_date)}
                </h5>
                <h5 className="text-start print-table-footer-label">
                  {salesInvoice.ship_via === "pick_up"
                    ? "Pick Up"
                    : salesInvoice.ship_via}
                </h5>
                <h5 className="text-start print-table-footer-label">
                  {dateFormat(salesInvoice.delivery_date)}
                </h5>
                {/* <h5 className="print-shop-header-elm invoice-2 d-flex justify-content-start">{salesInvoice.invoice_no}</h5> */}
              </div>
            </div>
          </div>

          {/* content */}
          <div className="mt-5 justify-content-start">
            {/* <Row className="d-flex align-items-start ms-5">
                            <Col xs={12} lg={6}>
                                <div className="d-flex my-2 align-items-center">
                                    <Col xs={4} className="print-label">
                                        Customer: 
                                    </Col>
                                    <Col xs={7} className="print-data">
                                        {salesInvoice.customer_name}
                                    </Col>
                                </div>
                                <div className="d-flex my-2 align-items-center">
                                    <Col xs={4} className="print-label">
                                        Address:
                                    </Col>
                                    <Col xs={7} className="print-data">
                                        {salesInvoice.address}
                                    </Col>
                                </div>
                                <div className="d-flex my-2 align-items-center">
                                    <Col xs={4} className="print-label">
                                        Contact No.
                                    </Col>
                                    <Col xs={7} className="print-data">
                                        {salesInvoice.contact_no}
                                    </Col>
                                </div>
                                <div className="d-flex my-2 align-items-center">
                                    <Col xs={4} className="print-label">
                                        Sales Date:
                                    </Col>
                                    <Col xs={7} className="print-data">
                                        {salesInvoice.sales_date ? dateFormat(salesInvoice.sales_date) : ""}
                                    </Col>
                                </div>
                            </Col>
                            <Col xs={12} lg={6} className="mt-2 mt-lg-0">
                                <div className="d-flex my-2 align-items-center">
                                    <Col xs={4} className="print-label">
                                        Branch:
                                    </Col>
                                    <Col xs={7} className="print-data">
                                        {salesInvoice.branch_name}
                                    </Col>
                                </div>
                                <div className="d-flex my-2 align-items-center">
                                    <Col xs={4} className="print-label">
                                        Delivery Date:
                                    </Col>
                                    <Col xs={7} className="print-data">
                                        {salesInvoice.delivery_date ? dateFormat(salesInvoice.delivery_date) : ""}
                                    </Col>
                                </div>
                                <div className="d-flex my-2 align-items-center">
                                    <Col xs={4} className="print-label">
                                        Ship Via:
                                    </Col>
                                    <Col xs={7} className="print-data">
                                        {salesInvoice?.ship_via?.split("_").join(" ")}
                                    </Col>
                                </div>
                                <div className="d-flex my-2 align-items-center">
                                    <Col xs={4} className="print-label">
                                        Acknowledged By:
                                    </Col>
                                    <Col xs={7} className="print-data">
                                        {salesInvoice.acknowledged_by_name}
                                    </Col>
                                </div>
                            </Col>
                        </Row> */}
            <div className="d-flex mt-2 justify-content-evenly">
              <div className="print-table mt-3 mx-2">{renderTable()}</div>
            </div>
            <Row className="mt-2">
              <span className="print-footer">
                for additional orders call 0917-511-1171
              </span>
            </Row>
            {salesInvoice.remarks && (
              <Row className="mt-2 ml-5">
                <span className="print-pi-address-elm print-data">
                  {" "}
                  Remarks: {salesInvoice.remarks}
                </span>
              </Row>
            )}
            <div className="d-flex flex-row gap-3 justify-content-end mx-3 mt-3">
              <div className="d-flex flex-column">
                <h5 className="text-end print-table-footer-label">Subtotal:</h5>
                <h5 className="text-end print-table-footer-label">discount:</h5>
                <h5 className="text-end print-table-footer-label">
                  discount subtotal:
                </h5>
                <h5 className="text-end print-table-footer-label">vat:</h5>
                <h5 className="text-end print-table-footer-label">
                  vatable sales:
                </h5>
                <h5 className="text-end print-table-footer-label">
                  wht ({formatDecimal(salesInvoice.withholding_percentage)} %):
                </h5>
                <h5 className="text-end print-table-footer-label">
                  grand total:
                </h5>
                <h5 className="text-end print-table-footer-label">
                  delivery service fee:
                </h5>
                <h5 className="text-end bold print-table-footer-label">
                  Total amount due:
                </h5>
              </div>
              <div>
                <h5 className="text-end print-table-footer-label">
                  {salesInvoice.subtotal
                    ? numberFormat(salesInvoice.subtotal)
                    : "0.00"}
                </h5>
                <h5 className="text-end print-table-footer-label">
                  {salesInvoice.discount
                    ? numberFormat(salesInvoice.discount)
                    : "0.00"}
                </h5>
                <h5 className="text-end print-table-footer-label">
                  {salesInvoice.discounted_subtotal
                    ? numberFormat(salesInvoice.discounted_subtotal)
                    : "0.00"}
                </h5>
                <h5 className="text-end print-table-footer-label">
                  {salesInvoice.vat ? numberFormat(salesInvoice.vat) : "0.00"}
                </h5>
                <h5 className="text-end print-table-footer-label">
                  {salesInvoice.vatable_sales
                    ? numberFormat(salesInvoice.vatable_sales)
                    : "0.00"}
                </h5>
                <h5 className="text-end print-table-footer-label">
                  {salesInvoice.withholding_tax
                    ? numberFormat(salesInvoice.withholding_tax)
                    : "0.00"}
                </h5>
                <h5 className="text-end print-table-footer-label">
                  {salesInvoice.grandtotal_without_service_fee
                    ? numberFormat(salesInvoice.grandtotal_without_service_fee)
                    : "0.00"}
                </h5>
                <h5 className="text-end print-table-footer-label">
                  {numberFormat(salesInvoice.service_fee) || "0.00"}
                </h5>
                <h5 className="text-end print-table-footer-label bold">
                  {salesInvoice.grand_total
                    ? numberFormat(salesInvoice.grand_total)
                    : "0.00"}
                </h5>
              </div>
            </div>
            {/* <Row className="print-grand-total mx-0 my-2 text-end">
              <Col xs={8} lg={11} md={6} className="print-table-footer-label ">
                SUBTOTAL
              </Col>
              <Col
                xs={2}
                lg={1}
                md={3}
                className="print-table-footer-data text-end"
              >
                {salesInvoice.subtotal
                  ? numberFormat(salesInvoice.subtotal)
                  : "0.00"}
              </Col>
            </Row>
            <Row className="print-grand-total mx-0 my-2 text-end">
              <Col xs={8} lg={11} md={6} className="print-table-footer-label">
                DISCOUNT
              </Col>
              <Col
                xs={2}
                lg={1}
                md={3}
                className="print-table-footer-data text-end"
              >
                {salesInvoice.discount
                  ? numberFormat(salesInvoice.discount)
                  : "0.00"}
              </Col>
            </Row>
            <Row className="print-grand-total mx-0 my-2 text-end">
              <Col xs={8} lg={11} md={6} className="print-table-footer-label">
                DISCOUNT SUBTOTAL
              </Col>
              <Col
                xs={2}
                lg={1}
                md={3}
                className="print-table-footer-data text-end"
              >
                {salesInvoice.discounted_subtotal
                  ? numberFormat(salesInvoice.discounted_subtotal)
                  : "0.00"}
              </Col>
            </Row> */}
            {/* <Row className="print-grand-total mx-0 my-2 text-end">
              <Col xs={8} lg={11} md={6} className="print-table-footer-label">
                VAT
              </Col>
              <Col
                xs={2}
                lg={1}
                md={3}
                className="print-table-footer-data text-end"
              >
                {salesInvoice.vat ? numberFormat(salesInvoice.vat) : "0.00"}
              </Col>
            </Row> */}
            {/* <Row className="print-grand-total mx-0 my-2 text-end">
              <Col xs={8} lg={11} md={6} className="print-table-footer-label">
                VATABLE SALES
              </Col>
              <Col
                xs={2}
                lg={1}
                md={3}
                className="print-table-footer-data text-end"
              >
                {salesInvoice.vatable_sales
                  ? numberFormat(salesInvoice.vatable_sales)
                  : "0.00"}
              </Col>
            </Row> */}
            {/* <Row className="print-grand-total mx-0 my-2 text-end">
              <Col xs={8} lg={11} md={6} className="print-table-footer-label">
                WHT({formatDecimal(salesInvoice.withholding_percentage)} %)
              </Col>
              <Col
                xs={2}
                lg={1}
                md={3}
                className="print-table-footer-data text-end"
              >
                {salesInvoice.withholding_tax
                  ? numberFormat(salesInvoice.withholding_tax)
                  : "0.00"}
              </Col>
            </Row> */}
            {/* <Row className="print-grand-total mx-0 my-2 text-end">
              <Col xs={8} lg={11} md={6} className="print-table-footer-label">
                GRAND TOTAL
              </Col>
              <Col
                xs={2}
                lg={1}
                md={3}
                className="print-table-footer-data text-end"
              >
                {salesInvoice.grandtotal_without_service_fee
                  ? numberFormat(salesInvoice.grandtotal_without_service_fee)
                  : "0.00"}
              </Col>
            </Row> */}
            {/* <Row className="print-grand-total mx-0 my-2 text-end">
              <Col xs={8} lg={11} md={6} className="print-table-footer-label">
                DELIVERY/SERVICE FEE
              </Col>
              <Col
                xs={2}
                lg={1}
                md={3}
                className="print-table-footer-data text-end"
              >
                {numberFormat(salesInvoice.service_fee) || "0.00"}
              </Col>
            </Row> */}
            {/* <Row className="print-grand-total mx-0 my-2 text-end">
              <Col
                xs={8}
                lg={11}
                md={6}
                className="bold print-table-footer-label"
              >
                TOTAL AMOUNT DUE
              </Col>
              <Col
                xs={2}
                lg={1}
                md={3}
                className="bold print-table-footer-data text-end"
              >
                {" "}
                {salesInvoice.grand_total
                  ? numberFormat(salesInvoice.grand_total)
                  : "0.00"}
              </Col>
            </Row> */}
            <Row className="print-grand-total mt-3 mx-0 my-2 text-end">
              <Col className="bold print-table-footer-label print-data">
                <span className="cheque-pay-to">
                  CHEQUE PAY TO ELMHURST ENTERPRISES
                </span>
              </Col>
            </Row>
            <Row className="print-signature mt-5 d-flex align-items-end justify-content-evenly gap-5 flex-md-row">
              <Col
                xs={12}
                sm={6}
                md={3}
                className="print-sig justify-content-center d-flex flex-column"
              >
                <img
                  src={salesInvoice.added_by_name_signature}
                  className="print-logo mx-auto"
                  alt=""
                />
                <p className="print-data underline-border text-center">
                  {salesInvoice.added_by_name}
                </p>
                <p className="print-data text-center mt-2">Prepared by</p>
              </Col>
              <Col
                xs={12}
                sm={6}
                md={3}
                className="print-sig justify-content-center d-flex flex-column"
              >
                <img
                  src={salesInvoice.acknowledged_by_name_signature}
                  className="print-logo mx-auto"
                  alt=""
                />
                <p className="print-data underline-border text-center">
                  {salesInvoice.acknowledged_by_name}
                </p>
                <p className="print-data text-center mt-2">Acknowledged by</p>
              </Col>
            </Row>
            {/* <Row className="mb-5"> */}
            {/* <Col xs={6} className="print-sig justify-content-center d-flex">
                <Row className="print-sig justify-content-center gotham">
                  {salesInvoice.added_by_name}
                  <div className="margin-underline"></div>
                  Prepared by
                  <p className="print-data underline-border text-center">
                    {salesInvoice.added_by_name}
                  </p>
                  <p className="print-data text-center mt-2">Prepared by</p>
                </Row>
              </Col> */}
            {/* <Col xs={6} className="print-sig justify-content-center d-flex">
                <Row className="print-sig justify-content-center gotham">
                  {salesInvoice.acknowledged_by_name}
                  <div className="margin-underline"></div>
                  Acknowledged by
                  <p className="print-data underline-border text-center">
                    {salesInvoice.acknowledged_by_name}
                  </p>
                  <p className="print-data text-center mt-2">Acknowledged by</p>
                </Row>
              </Col> */}
            {/* <Col xs={3} className="print-sig justify-content-center d-flex">
                                <Row className="print-sig justify-content-center gotham">
                                    <div className="margin-underline"></div>
                                    Recieved by
                                </Row>
                            </Col>
                            <Col xs={3} className="print-sig justify-content-center d-flex">
                                <Row className="print-sig justify-content-center gotham">
                                    <div className="margin-underline"></div>
                                    Released by
                                </Row>
                            </Col> */}
            {/* </Row> */}
          </div>
        </div>

        <div className="mt-4 noPrint mx-3">
          <Row className="review-data mb-2">FILE ATTACHMENTS</Row>
          <Row>
            <Col xs={6} lg={1}>
              <div className="d-flex flex-row gap-2 overflow-auto">
                {fileList &&
                  fileList.map((attachment, index) => (
                    <div
                      // onClick={() => {
                      //   setPreviewFile(attachment.file_url)
                      //   setPreview(true)
                      // }}
                      key={index}
                      className="thumbnail-cont"
                    >
                      <img
                        src={attachment.file_url}
                        className="image-thumbnail"
                        alt=""
                        onClick={() => handleClickImageThumbnail(index)}
                      />
                    </div>
                  ))}
                {!fileList ||
                  (fileList.length === 0 && (
                    <div>
                      <div className="no-data-cont d-flex justify-content-left preview-container">
                        <img
                          src={noDataImg}
                          alt="no data found"
                          className="img-preview"
                        />
                      </div>
                    </div>
                  ))}
              </div>
            </Col>
          </Row>
        </div>

        <Container
          fluid
          className="PI-payment-info-wrapper mt-5 py-3 px-3 edit-form"
        >
          <h5 className="PI-payment-info">PAYMENT HISTORY</h5>
          <div className="justify-content-center">
            <TableTemp
              tableHeaders={[
                "PMT DATE",
                "INV NO.",
                "TYPE",
                "PAID AMT",
                "DEPOSIT AMT",
                "DEPOSIT DATE",
                "DEPOSITED TO",
                "REMARKS",
              ]}
              headerSelector={[
                "payment_date",
                "invoice_no",
                "payment_type",
                "paid_amount",
                "deposit_amount",
                "deposit_date",
                "to_bank_name",
                "remarks",
              ]}
              tableData={paymentInfo}
            />
          </div>
        </Container>

        {/* footer */}
        <div className="d-flex justify-content-end my-4 pb-5 d-flex-responsive">
          <button
            className="button-secondary me-3"
            onClick={() => navigate("/salesorder")}
          >
            Close
          </button>
          {salesInvoice.payment_status === "open_bill" && isAdmin() ? (
            <button
              className="button-tertiary me-3"
              onClick={() => navigate("/salesorder/edit/" + id)}
            >
              Edit
            </button>
          ) : (
            ""
          )}
          {salesInvoice.fs_status === "processing" && (
            <button
              className="button-secondary me-3"
              onClick={handlePrintWarehouse}
            >
              Print Warehouse
            </button>
          )}
          <button className="button-primary" onClick={handlePrint}>
            Print
          </button>
        </div>
      </div>
      <Footer />
      <Modal
        open={preview}
        title={""}
        footer={null}
        onCancel={() => setPreview(false)}
      >
        <img
          alt="example"
          style={{
            width: "100%",
          }}
          src={previewFile}
        />
      </Modal>
      <AttachmentModal
        show={showAttachmentsModal}
        images={fileList}
        onHide={() => handleCloseAttachmentsModal()}
        selected={startAt}
      />
    </div>
  )
}
